import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from 'react';
import { BoardFilters, Button, RemoteCount } from "../index";
function BoardCount(props) {
    const { id, objectType } = props;
    const [openFilters, setOpenFilters] = useState(false);
    const filterButtons = [
        _jsx(Button, { outline: true, position: "right", type: "primary", onClick: () => setOpenFilters(true), icon: "filter", className: "count-filter-button" }, "board-count-filter")
    ];
    return (_jsxs("div", { style: { height: "100%" }, children: [_jsx(BoardFilters, { endpoint: objectType, entityType: "component", open: openFilters, setOpen: setOpenFilters, ...props }), _jsx(RemoteCount, { id: id, title: props.title, buttons: filterButtons, endpoint: objectType, baseUrl: props.baseUrl, zone: props.zone, setZone: props.setZone })] }));
}
export default BoardCount;
